import api from './api'

export default (resource) => {
  return {
    namespaced: true,
    state: {
      user: null,
      userId: null,
    },
    getters: {
      isSignedIn: (_, getters) => {
        return !!getters.getUserId() && !!getters.getToken()
      },
      getToken: (state) => () => localStorage.getItem('token'),
      getUserId: (state) => () => localStorage.getItem('userId'),
      currentUser: (state) => state.user,
      currentUserId: (state) => state.userId,
      currentUserRole: (state) => state.user.admin_role,
      currentUserAdminId: (state) => state.user.admin_id,
    },
    mutations: {
      SET_TOKEN(_, token) {
        localStorage.setItem('token', token)
      },
      SET_USER(state, user) {
        state.user = user
        localStorage.setItem('user', JSON.stringify(user))
      },
      SET_USERID(state, userId) {
        localStorage.setItem('userId', userId)
        state.userId = userId
      },
      SIGN_OUT(state) {
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        localStorage.removeItem('userId')
        state.user = null
        state.userId = null
      },
    },
    actions: {
      authenticate: async ({ commit }, { user, password }) => {
        try {
          const {
            data: { token, userId },
          } = await api.post(`/${resource}`, {
            user,
            password,
          })
          commit('SET_TOKEN', token)
          commit('SET_USERID', userId)
        } catch (err) {
          throw new Error('Email eller lösenord matchar inte')
        }
      },
      updatePassword: async ({}, payload) => {
        try {
          const { id } = payload
          await api.put(`/${resource}/${id}`, payload)
        } catch (err) {
          throw new Error('Email eller lösenord matchar inte')
        }
      },
    },
  }
}
